const intialQty = () => {
  var floating_init_QTY = document.querySelector('.floating-cart [name="quantity"]');
  var initqty = document.querySelector('.product-form__item--quantity [name="quantity"]');
  if(initqty && floating_init_QTY){
    floating_init_QTY.value = initqty.value;
  }
}

var selectedDropdown = document.querySelector('#SingleOptionSelector');
document.addEventListener("variant:change", (e) => {
  if (selectedDropdown) {
    selectedDropdown.value = e.detail.variant?.id;
  }
  document.querySelector('.var-title').textContent = e.detail.variant?.title;
  intialQty();
})

if(selectedDropdown){
  selectedDropdown.addEventListener("change", function(evt){
    var variantJson = document.querySelector('[data-product-json]');
    var variantObject = JSON.parse(variantJson.innerHTML);
    var variantsArray = variantObject.variants;
    let filterVariant = variantsArray.filter(function (variant) {
     if(variant.id == evt.target.value){
      return variant;
     }
    })
    var OptionVal1 = filterVariant[0].option1;
    if(OptionVal1 != 'null'){
      // $(`[data-value="${OptionVal1}"] input`).trigger("click");
      document.querySelector(`[data-value="${OptionVal1}"] input`).click();
    }
  
    var OptionVal2 = filterVariant[0].option2;
    if(OptionVal2 != ''){
      document.querySelector(`[data-value="${OptionVal2}"] input`).click();
    }
    var OptionVal3 = filterVariant[0].option3;
    if(OptionVal3 != ''){
      document.querySelector(`[data-value="${OptionVal3}"] input`).click();
    }
    
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    intialQty();
  }, 1000);
})